import * as React from 'react';
import { IconToggleStarOff24, IconToggleStarOn24 } from '@cian/ui-kit-design-tokens/icons';

import * as style from './Rating.css';
import { UIHeading4 } from '@cian/ui-kit';
import { RATING_TEXTS } from '../../constants/feedbackText';

const STARS_COUNT = 5;

type RatingProps = {
  rating: number;
  onStarClick: (index: number) => void;
};

export const Rating: React.FC<RatingProps> = ({ rating, onStarClick }) => {
  const stars = React.useMemo(() => {
    const updatedStars = [];

    for (let i = 0; i < STARS_COUNT; i++) {
      if (i < rating) {
        updatedStars.push(
          <IconToggleStarOn24
            color="warning_100"
            key={i}
            data-testid="icon-toggle-star-on"
            onClick={() => onStarClick(i)}
          />,
        );
      } else {
        updatedStars.push(
          <IconToggleStarOff24
            color="gray60_100"
            key={i}
            data-testid="icon-toggle-star-off"
            onClick={() => onStarClick(i)}
          />,
        );
      }
    }

    return updatedStars;
  }, [rating, onStarClick]);

  return (
    <div>
      <div className={style['stars-container']}>{stars}</div>
      <UIHeading4 color="gray60_100" textAlign="center">
        {RATING_TEXTS[rating]}
      </UIHeading4>
    </div>
  );
};
